import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // wait one frame for GSAP layout changes
    requestAnimationFrame(() => {
      ScrollTrigger.refresh(true);
      window.scrollTo(0, 0);
    });
  }, [pathname]);

  return null;
}
